import { render, staticRenderFns } from "./Beneficios.vue?vue&type=template&id=3e10adfe"
import script from "./Beneficios.vue?vue&type=script&lang=js"
export * from "./Beneficios.vue?vue&type=script&lang=js"
import style0 from "./Beneficios.vue?vue&type=style&index=0&id=3e10adfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports